// extracted by mini-css-extract-plugin
module.exports = {"wptext":"HeadingDetails_wptext__316tG"};